import React from 'react';

import { useDataHelper } from 'utils/dataHelper';
import { breakoutRoomInviteModel } from 'entities/breakoutRoomInviteModel';
import { theme } from 'theme';
import { styled } from '@material-ui/core/styles';

import { SdmTypography, SdmSpacer } from 'components';

import Grid from '@material-ui/core/Grid';

import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

const CalendarLink = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
});

export const SubHeader = ({
  fetchedBr,
  i18n,
  onAddCalendar,
  hideStatus = false,
}) => {
  const { getFormattedDate, checkPassedDate } = useDataHelper();

  const handleAddCalendar = (br) => {
    onAddCalendar && onAddCalendar(br);
  };

  return (
    <>
      <Grid item md={2} sm={2}></Grid>
      <Grid item md={8} sm={8} xs={12}>
        <Grid container alignItems={'center'} justify={'space-around'}>
          <SdmTypography
            variant={'h4Regular'}
            style={{ color: theme.colors.primary.grey }}
          >
            {getFormattedDate(fetchedBr, true, 'row')}
          </SdmTypography>
          {fetchedBr.status === breakoutRoomInviteModel.enums.status.ACCEPTED &&
          !checkPassedDate(fetchedBr?.end) ? (
            <CalendarLink>
              <CalendarTodayIcon
                style={{
                  color: theme.colors.primary.red,
                  marginRight: 8,
                }}
              />
              <SdmTypography
                variant={'h3'}
                margin={0}
                style={{
                  color: theme.colors.primary.red,
                  cursor: 'pointer',
                }}
                onClick={handleAddCalendar}
              >
                {i18n.buttons.calendar}
              </SdmTypography>
            </CalendarLink>
          ) : null}
          {!hideStatus && (
            <SdmTypography
              variant={'h5Regular'}
              margin={0}
              style={{
                color: theme.colors.primary.grey,
                textTransform: 'uppercase',
              }}
            >
              {fetchedBr.status}
            </SdmTypography>
          )}
        </Grid>
      </Grid>
      <Grid item md={2} sm={2}></Grid>
      <SdmSpacer height={40} />
    </>
  );
};
